<template>
    <div class="products-points">
        <Input @input="handleChangeName" :placeholder="getMessageByLang('namePoint', 'Название пункта')" :value="pointVal.name" />
        <NumericTextBox @change="handleChangePrice" :placeholder="getMessageByLang('priceText', 'Цена')" :value="pointVal.price" />

        <div>
            <KButton :svg-icon="trashIcon" @click="handleDelete" />
        </div>
    </div>
</template>

<script setup>
import {defineEmits, defineProps, ref} from 'vue';

import { Input } from "@progress/kendo-vue-inputs";
import { Button as KButton } from "@progress/kendo-vue-buttons";
import { trashIcon  } from "@progress/kendo-svg-icons";
import { NumericTextBox } from '@progress/kendo-vue-inputs';
import { getMessageByLang } from '@/utils/translate.js';

const props = defineProps({
    index: {
        type: Number,
        required: false,
        default: null
    },
    pointIndex: {
        type: Number,
        required: false,
        default: null
    },
    optionIndex: {
        type: Number,
        required: false,
        default: null
    },
    point: {
        type: Object,
        required: true
    }
})

const emits = defineEmits(['delete', 'change']);
const pointVal = ref(props.point || {
    name: '',
    price: '',
    visible: true
})

const handleChangeName = (event) => {
    pointVal.value.name = event.target.value;
    emits('change', {
        optionIndex: props.optionIndex,
        pointIndex: props.pointIndex,
        data: pointVal.value
    });
}

const handleChangePrice = (event) => {
    pointVal.value.price = event.target.value;
    emits('change', {
        optionIndex: props.optionIndex,
        pointIndex: props.pointIndex,
        data: pointVal.value
    });
}

const handleDelete = () => {
    emits('delete', {index: props.index});
}
</script>


<style lang="scss" scoped>
.products-points {
    display: grid;
    grid-template-columns: repeat(3, 1fr); 
    gap: .5rem;
    align-items: flex-start;
}
</style>